// Single user_settings key holding the tri-state onboarding state (absent | in-progress | completed).
export const SOIL_SIGHT_ONBOARDING_SETTING = "soilSightOnboarding";

// Below this uplift the improved-scenario step switches to its "low lift" variant.
export const LOW_LIFT_THRESHOLD_PCT = 5;

// Uplifts within ±epsilon of zero are treated as "no change".
export const NO_CHANGE_EPSILON_PCT = 0.5;

// Minimum growing window (regional avg harvest → next crop seeding) required to recommend a cover crop.
export const COVER_CROP_MIN_GROWING_WINDOW_DAYS = 42;

export type OnboardingPracticeKey = "residue" | "tillage" | "coverCrop";

// Practices the generated adapted scenario applies out of the box; cover crops stay opt-in on step 3.
export const IS_PRACTICE_APPLIED_BY_DEFAULT: Record<OnboardingPracticeKey, boolean> = {
  residue: true,
  tillage: true,
  coverCrop: false,
};

export const SOIL_SIGHT_FLOW_ROUTES = {
  scenarios: "/scenarios",
  onboardingStep1: "/scenarios-onboarding/step-1",
  landing: "/scenarios-landing-page",
} as const;

export type SoilSightFlowRoute = (typeof SOIL_SIGHT_FLOW_ROUTES)[keyof typeof SOIL_SIGHT_FLOW_ROUTES];
